
import { store }                from 'index';
import { SET_COMPONENTS_STATE } from 'actions';
import { objType }              from 'types';

const handleReduceTen = () => {

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))

    const payload = { 
        ...componentsState,
        tens: {
            ...componentsState.tens,
            value: componentsState.tens.value - 1
        },
    };

    setComponentsState(payload);
}

export default handleReduceTen